"use client";

import NextLink from "next/link";
import { Dropdown, Navbar, SpheronApp } from "@spheron/ui-library";
import Console from "@spheron/ui-library/dist/assets/compute/console.svg";
import FizzNode from "@spheron/ui-library/dist/assets/compute/multi-service.svg";
import SpheronMenu from "@spheron/ui-library/dist/assets/spheron-menu.svg";
import SpheronIcon from "@spheron/ui-library/dist/assets/spheron-specific/spheron-logo.svg";

const NavbarComponent = () => {
  const dropdownItems = [
    {
      id: 1,
      label: "CONSOLE",
      handleClick: () => window.open("https://console.spheron.network"),
      icon: <Console className="w-8 h-8" />,
    },
    {
      id: 2,
      label: "FIZZ NODE",
      handleClick: () => window.open("https://fizz.spheron.network"),
      icon: <FizzNode className="w-8 h-8" />,
    },
  ];

  return (
    <Navbar
      logoIcon={
        <div className="flex items-center justify-start gap-x-2">
          <Dropdown
            dropdownType="button"
            className="w-fit"
            dropdownSize="default"
            bordersNone
            dropdownClassname="w-fit !ml-1"
            buttonImage={
              <button
                className="p-0.5 rounded
                transition hover:bg-action-ghost-press dark:hover:bg-dark-action-ghost-press"
              >
                <SpheronMenu className="w-8 h-8 text-logo-primary dark:text-dark-logo-primary" />
              </button>
            }
            options={dropdownItems.map((app) => {
              return {
                id: app.id,
                optionType: "primary",
                dropdownRowClassname:
                  "hover:bg-transparent dark:hover:bg-transparent",
                label: (
                  <div className="w-80">
                    <SpheronApp
                      heading={
                        <div className="flex items-center justify-start gap-x-2">
                          <SpheronIcon className="w-6 h-6 text-logo-primary dark:text-dark-logo-primary" />
                          <span className="font-semibold">{app.label}</span>
                        </div>
                      }
                      helpText=""
                      icon={app.icon}
                    />
                  </div>
                ),
                handleClick: () => app.handleClick(),
              };
            })}
          />
          <NextLink href="/">
            <div className="flex items-center justify-start gap-x-1">
              <SpheronIcon className="w-10 h-10 text-logo-primary dark:text-dark-logo-primary" />
              <span className="text-base font-semibold">PROVIDER</span>
            </div>
          </NextLink>
        </div>
      }
      infoElements={<></>}
    />
  );
};

export default NavbarComponent;
